import React from 'react';
import ReactDOM from 'react-dom/client';
import './api/authFetch'; // side-effect: patch fetch to attach the JWT to backend calls
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Silence console output in production builds so nothing is logged in users' browsers.
// Development (npm start) keeps full logging. console.error is preserved for crash traces.
if (process.env.NODE_ENV === 'production') {
  const noop = () => {};
  ['log', 'info', 'debug', 'warn'].forEach((method) => {
    try {
      // eslint-disable-next-line no-console
      console[method] = noop;
    } catch (e) {
      /* ignore */
    }
  });
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // First, register the service worker
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('Service Worker initially registered:', registration);

        // Unregister the service worker after initial registration
        return registration.unregister().then((boolean) => {
          console.log(`Service Worker unregistered: ${boolean}`);

          // Register the service worker again after unregistering
          return navigator.serviceWorker.register('/service-worker.js')
            .then((newRegistration) => {
              console.log('Service Worker re-registered:', newRegistration);
            })
            .catch((error) => {
              console.error('Service Worker re-registration failed:', error);
            });
        });
      })
      .catch((error) => {
        console.error('Initial Service Worker registration failed:', error);
      });
  });
}

// Hand the auth token to the service worker so its background timer heartbeat
// (POST /timers) is authenticated — SWs can't read localStorage themselves.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.ready
    .then((reg) => {
      const token = localStorage.getItem('userValue');
      if (token && reg.active) {
        reg.active.postMessage({ action: 'setToken', token });
      }
    })
    .catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
